<template>
  <div class="w-100 d-flex flex-column align-items-center">
    <h2 class="text-success mb-3">Confirmação de E-mail</h2>
    <b-form-group
      label="Digite o código de verificação recebido por e-mail:"
      label-for="codigo-verificacao"
      class="mt-3"
    >
      <b-form-input
        id="codigo-verificacao"
        v-model="codigo"
        placeholder="Código de verificação"
        class="text-center"
      ></b-form-input>
    </b-form-group>
    <div class="botoes d-flex">
      <b-button variant="outline-secondary" class="mt-3 mr-2" @click="reenviar">
        Reenviar e-mail
      </b-button>
      <b-button variant="success" class="mt-3" @click="confirmarCodigo">
        Verificar
      </b-button>
    </div>
    <b-alert v-if="mensagem" variant="success" show class="mt-3">
      {{ mensagem }}
    </b-alert>
  </div>
</template>

<script lang="ts">
/**
 * TODO: Documentar corretamente o funcionamento desta página vs a ConfirmaCodigo.vue.
 * Escrever testes separados para cada uma.
 */
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { store } from "@/store";
import usuarioService from "@/services/administracao/usuarioService";

const CompProps = Vue.extend({
  name: "ConfirmaEmail",
});

@Component
export default class ConfirmaEmail extends mixins(UtilsTS, CompProps) {
  mensagem = "";
  codigo = "";

  async confirmarCodigo(): Promise<void> {
    store.blockScreen = true;
    try {
      await usuarioService.confirmarCodigoAtivacao(this.codigo);
      this.$toast.success("Código confirmado com sucesso!");
      this.$emit('confirmado')
    } catch (e: unknown) {
      this.tratarError(e, true);
    } finally {
      store.blockScreen = false;
      this.codigo = "";
    }
  }

  async reenviar(): Promise<void> {
    this.$bvModal
      .msgBoxConfirm(`Deseja receber um novo código?`, {
        buttonSize: "sm",
        cancelTitle: "Cancelar",
        cancelVariant: "outline-secondary",
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        okTitle: "Confirmar",
        okVariant: "secondary",
        title: "Reenvio de código",
      })
      .then((v) => {
        if (v) this.reenviarAtivacao();
      })
      .catch((err) => {
        console.error(
          `Erro ao operar o dialog de alerta de reativação de usuário`,
          err
        );
      });
  }
  async reenviarAtivacao(): Promise<void> {
    try {
      store.blockScreen = true;
      await usuarioService.reenviarAtivacao();
      this.$toast.info("E-mail reenviado com sucesso!");
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      store.blockScreen = false;
    }
  }
}
</script>
